import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST,
  GET_NOTIFICATIONRECIPIENTS,
  SEND_NOTIFICATIONS,
  MARK_TRIP_NO_SHOW,
  EDIT_DUTY_SLIP,
  GET_ALL_CITIES,
  GET_RATE_CARDS_V2,
  GET_RATE_ESTIMATE,
  GET_TOLL_CHARGES,
  ADD_TOLL_CHARGE,
  UPDATE_TOLL_CHARGE,
  DELETE_TOLL_CHARGE,
} from "resources/actionTypes";

const initialReservationListState = {
  loading: false,
  error: null,
  reservationList: "",
};

const initialReservationDetailsState = {
  loading: false,
  error: null,
  reservationDetails: "",
};

const initialState = {
  loading: false,
  error: null,
  bookingResponse: "",
};

const initialUpdateReservation = {
  loading: false,
  error: null,
  updateReservation: "",
};

const initialDownload = {
  loading: false,
  error: null,
  downloadReport: "",
};

const initialCancelReasonState = {
  loading: false,
  error: null,
  cancelReason: "",
};

const initialBookingBufferTimeState = {
  loading: false,
  error: null,
  bufferTime: "",
};

const initialAirportTerminalsState = {
  loading: false,
  error: null,
  airportTerminalList: "",
};

const initialNotificationRecipientsState = {
  loading: false,
  error: null,
  notificationRecipients: "",
};

const initialSendNotificationsState = {
  loading: false,
  error: null,
  sendNotificationsData: "",
};

const initialMarkNoShowState = {
  loading: false,
  error: null,
  markNoShowData: "",
};
const initialEditDutySlipState = {
  loading: false,
  error: null,
  editDutySlipData: "",
};

const initialAllCitiesState = {
  loading: false,
  error: null,
  allCitiesList: "",
};

const initialRateCardsV2State = {
  loading: false,
  error: null,
  rateCardsV2List: "",
};

const initialRateEstimateState = {
  loading: false,
  error: null,
  rateEstimateData: "",
};

export const markTripAsNoShow = (state = initialMarkNoShowState, action) => {
  switch (action.type) {
    case MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_SUCCESS:
      return {
        ...state,
        loading: false,
        markNoShowData: action.markNoShowData,
      };
    case MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
export const getReservationList = (
  state = initialReservationListState,
  action,
) => {
  switch (action.type) {
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationList: action.reservationList,
      };
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getReservationDetails = (
  state = initialReservationDetailsState,
  action,
) => {
  switch (action.type) {
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationDetails: action.reservationDetails,
      };
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_RESERVATIONDETAILS.CLEAR_RESERVATIONDETAILS:
      return {
        ...state,
        loading: false,
        reservationDetails: "",
      };
    default:
      return state;
  }
};

export const addReservation = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDRESERVATION.GET_ADDRESERVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingResponse: action.addReservationList,
      };
    case GET_ADDRESERVATION.GET_ADDRESERVATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateReservation = (state = initialUpdateReservation, action) => {
  switch (action.type) {
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getDownLoadList = (state = initialDownload, action) => {
  switch (action.type) {
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadData: action.downloadReport,
      };
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCancelReason = (state = initialCancelReasonState, action) => {
  switch (action.type) {
    case GET_CANCELREASON.GET_CANCELREASON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELREASON.GET_CANCELREASON_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelReason: action.cancelReason,
      };
    case GET_CANCELREASON.GET_CANCELREASON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBookingBufferTime = (
  state = initialBookingBufferTimeState,
  action,
) => {
  switch (action.type) {
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        bufferTime: action.bufferTime,
      };
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getAirportTerminalList = (
  state = initialAirportTerminalsState,
  action,
) => {
  switch (action.type) {
    case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        airportTerminalList: action.airportTerminalsDetails,
      };
    case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getNotificationRecipients = (
  state = initialNotificationRecipientsState,
  action,
) => {
  switch (action.type) {
    case GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_REQUESTED:
      return { ...state, loading: true };
    case GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationRecipients: action.notificationRecipients,
      };
    case GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_NOTIFICATIONRECIPIENTS.CLEAR_NOTIFICATIONRECIPIENTS:
      return { ...state, loading: false, notificationRecipients: "" };
    default:
      return state;
  }
};

export const sendNotifications = (
  state = initialSendNotificationsState,
  action,
) => {
  switch (action.type) {
    case SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_REQUESTED:
      return { ...state, loading: true };
    case SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        sendNotificationsData: action.sendNotificationsData,
      };
    case SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_FAILED:
      return { ...state, loading: false, error: action.message };
    case SEND_NOTIFICATIONS.CLEAR_SEND_NOTIFICATIONS:
      return { ...state, loading: false, sendNotificationsData: "" };
    default:
      return state;
  }
};

export const editDutySlip = (state = initialEditDutySlipState, action) => {
  switch (action.type) {
    case EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        editDutySlipData: action.payload,
      };
    case EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const allCitiesReducer = (state = initialAllCitiesState, action) => {
  switch (action.type) {
    case GET_ALL_CITIES.GET_ALL_CITIES_REQUESTED:
      return { ...state, loading: true };
    case GET_ALL_CITIES.GET_ALL_CITIES_SUCCESS:
      return { ...state, loading: false, allCitiesList: action.allCitiesList };
    case GET_ALL_CITIES.GET_ALL_CITIES_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_ALL_CITIES.CLEAR_ALL_CITIES:
      return { ...state, loading: false, allCitiesList: "" };
    default:
      return state;
  }
};

export const rateCardsV2Reducer = (state = initialRateCardsV2State, action) => {
  switch (action.type) {
    case GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_REQUESTED:
      return { ...state, loading: true };
    case GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_SUCCESS:
      return {
        ...state,
        loading: false,
        rateCardsV2List: action.rateCardsV2List,
      };
    case GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_RATE_CARDS_V2.CLEAR_RATE_CARDS_V2:
      return { ...state, loading: false, rateCardsV2List: "" };
    default:
      return state;
  }
};

export const rateEstimateReducer = (
  state = initialRateEstimateState,
  action,
) => {
  switch (action.type) {
    case GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_REQUESTED:
      return { ...state, loading: true };
    case GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_SUCCESS:
      return {
        ...state,
        loading: false,
        rateEstimateData: action.rateEstimateData,
      };
    case GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_RATE_ESTIMATE.CLEAR_RATE_ESTIMATE:
      return { ...state, loading: false, rateEstimateData: "" };
    default:
      return state;
  }
};

const initialTollChargesState = {
  loading: false,
  error: null,
  tollCharges: null,
};

export const getTollChargesReducer = (state = initialTollChargesState, action) => {
  switch (action.type) {
    case GET_TOLL_CHARGES.GET_TOLL_CHARGES_REQUESTED:
      return { ...state, loading: true };
    case GET_TOLL_CHARGES.GET_TOLL_CHARGES_SUCCESS:
      return { ...state, loading: false, tollCharges: action.payload };
    case GET_TOLL_CHARGES.GET_TOLL_CHARGES_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};

const initialAddTollState = {
  loading: false,
  error: null,
  success: false,
};

export const addTollChargeReducer = (state = initialAddTollState, action) => {
  switch (action.type) {
    case ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_SUCCESS:
      return { ...state, loading: false, success: true };
    case ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};

const initialUpdateTollState = {
  loading: false,
  error: null,
  success: false,
};

export const updateTollChargeReducer = (state = initialUpdateTollState, action) => {
  switch (action.type) {
    case UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_SUCCESS:
      return { ...state, loading: false, success: true };
    case UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};

const initialDeleteTollState = {
  loading: false,
  error: null,
  success: false,
};

export const deleteTollChargeReducer = (state = initialDeleteTollState, action) => {
  switch (action.type) {
    case DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_SUCCESS:
      return { ...state, loading: false, success: true };
    case DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};
